import React, { Component } from "react";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import "scss/components/modals/users/addTeamModal.scss";

export default class AddTeamModal extends Component {
  render() {
    return (
      <Modal
        closeIcon
        dimmer="blurring"
        size="tiny"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header>
          <Icon name="user" />
          &nbsp;เพิ่มทีมงาน
        </Modal.Header>
        <Modal.Content className="team">
          <div>
            <Form>
              <Form.Field>
                <label>ชื่อทีมงาน</label>
                <input
                  type="text"
                  placeholder="ชื่อทีมงาน"
                  style={{ fontFamily: "Kanit" }}
                />
              </Form.Field>
            </Form>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={() => this.props.isClose()}>
            ยกเลิก
          </Button>
          <Button positive onClick={() => this.props.isClose()}>
            ตกลง
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
